import React from "react";
import { Responsive } from "../../interface/redux/config";
import BusinessTitleSection from "../../components/Business/BusinessTitleSection/BusinessTitleSection";
import TopstSection1 from "../../components/Business/Topst/TopstSection1";
import TopstSection2 from "../../components/Business/Topst/TopstSection2";
import { useLanguage } from "../../hooks/useLanguage";

type Props = {
  Desktop: Responsive;
  PcTablet: Responsive;
  Tablet: Responsive;
  Mobile: Responsive;
};

const Topst = ({ Desktop, PcTablet, Mobile, Tablet }: Props) => {
  const { isKr } = useLanguage();
  return (
    <div>
      <BusinessTitleSection
        Desktop={Desktop}
        PcTablet={PcTablet}
        Mobile={Mobile}
        tag='HUCONN BUSINESS | TOPST'
        title={`TOPST`}
        sub={isKr
          ? `Total Open Platform for System development and Training
누구나 자유롭게 사용하는 기술, 누구나 쉽게 설계할 수 있는 기술`
          : `Total Open Platform for System development and Training
Technology freely accessible to everyone, technology anyone can easily design`}
        mb={isKr
          ? `Total Open Platform for
System development and Training
누구나 자유롭게 사용하는 기술,
누구나 쉽게 설계할 수 있는 기술`
          : `Total Open Platform for
System development and Training
Technology freely accessible to everyone,
technology anyone can easily design`}
        bgstyle='pc:bg-topst-title-pc tablet:bg-topst-title-tablet mb:bg-topst-title-mb'
      />
      <TopstSection1 Desktop={Desktop} Tablet={Tablet} />
      <TopstSection2 Desktop={Desktop} Tablet={Tablet} Mobile={Mobile} />
    </div>
  );
};

export default Topst;
